import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const GoogleSignInButton = styled(Button)`
  color: #212121;
  background-color: white;
  font-weight: 600;
  text-transform: none;

  :hover {
    background-color: #eee;
  }
`;

